import { useEffect, useRef, useState } from 'react';
import Header from '@/components/Header';
import Clients from '@/components/Clients';
import CaseStudy from '@/components/CaseStudy';
import Footer from '@/components/Footer';
const ClientsPage = () => {
  const observerRef = useRef<IntersectionObserver | null>(null);
  const [dots, setDots] = useState<{
    x: number;
    y: number;
    size: number;
    opacity: number;
    speed: number;
  }[]>([]);
  useEffect(() => {
    // Generate static background dots - no animation to improve performance
    const generateDots = () => {
      const newDots = [];
      for (let i = 0; i < 30; i++) {
        // Same as Hero component
        newDots.push({
          x: Math.random() * 100,
          y: Math.random() * 100,
          size: Math.random() * 3 + 1,
          opacity: Math.random() * 0.2 + 0.05,
          speed: Math.random() * 0.5 + 0.1
        });
      }
      setDots(newDots);
    };
    generateDots();

    // Set up scroll animations for elements with reveal-on-scroll class
    observerRef.current = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('active');
          // Once activated, we don't need to observe it anymore
          observerRef.current?.unobserve(entry.target);
        }
      });
    }, {
      root: null,
      rootMargin: '20px 0px',
      threshold: 0.01
    });

    // Select all elements with the class and observe them
    const elements = document.querySelectorAll('.reveal-on-scroll');
    elements.forEach(el => observerRef.current?.observe(el));

    // Cleanup
    return () => {
      if (observerRef.current) {
        observerRef.current.disconnect();
      }
    };
  }, []);
  return <div className="min-h-screen bg-light">
      <Header />
      
      {/* Background section with animated dots - no content */}
      
      
      {/* Content sections */}
      <div className="apple-section">
        <div className="reveal-on-scroll">
          <Clients />
        </div>
      </div>
      
      <div className="apple-section">
        <div className="reveal-on-scroll">
          <CaseStudy />
        </div>
      </div>
      
      <Footer />
    </div>;
};
export default ClientsPage;